




















































































import { Vue, Component, Watch } from "vue-property-decorator";
import { UserService, SkcServerOrderService } from "src/services";
import { IServerModel } from "src/model";
import router from "../../router";
import voucher from "./sub/voucher.vue";
import userAgreement from "../login/sub/userAgreement.vue";

@Component({
  components: {
    voucher,
    userAgreement,
  },
})
export default class payType extends Vue {
  /**
   * 服务协议
   * @protected
   * @returns UserService
   */
  protected actionAgreement(): void {
    (this.$refs.userAgreement as any).show();
  }
  /**
   * 定时器
   * @private
   * @return any
   */
  private dsq: any = null;

  /**
   * 支付方式
   * @private
   * @return Array<any>
   */
  private payType: Array<any> = [
    { id: 0, name: "微信支付", checked: true, ico: "../../icon/weChart.png" },
    { id: 1, name: "线下汇款", checked: false, ico: "../../icon/ylPay.png" },
  ];
  /**
   * 微信二维码base64
   * @private
   * @return string
   */
  private weImg: string = "";

  /**
   * 获取平台服务
   * @private
   * @return SkcServerOrderService
   */
  private _skcServerOrderService: SkcServerOrderService;

  /**
   * 获取或设置用户服务。
   * @protected
   * @returns UserService
   */
  protected get skcServerOrderService(): SkcServerOrderService {
    if (!this._skcServerOrderService) {
      this._skcServerOrderService = this.$serviceProvier.resolve<SkcServerOrderService>(SkcServerOrderService);
    }

    return this._skcServerOrderService;
  }

  /**
   * 获取用户服务
   * @private
   * @return UserService
   */
  private _userService: UserService;

  /**
   * 弹框显示
   * @protected
   * @returns
   */
  protected visible: boolean = false;

  /**
   * 获取或设置用户服务。
   * @protected
   * @returns UserService
   */
  protected get userService(): UserService {
    if (!this._userService) {
      this._userService = this.$serviceProvier.resolve<UserService>(UserService);
    }

    return this._userService;
  }

  /**
   * 用户信息
   * @protected
   * @type {any}
   */
  protected get userInfo(): any {
    return this.$store.getters["global/userInfo"];
  }

  /**
   * 获取用户信息
   * @private
   * @return Promise<void>
   */
  private async getLoginInfo(): Promise<void> {
    try {
      let { content: result } = await this.userService.getLoginInfo();
      if (result.data) {
        // 存储登入所有信息
        this.$store.dispatch("user/setProfile", result.data);
      }
    } catch (err) {
      this.$message.error({
        duration: 3,
        content: JSON.stringify(err),
      });
    }
  }

  /**
   * 组件创建钩子。
   * @protected
   * @returns void
   */
  protected created(): void {
    if (this.$route.query.id) {
      let id = parseInt((this.$route.query as any).id);
      this.getPay({ id: id, payTransType: 1 });
      this.getSkcServerOrder(id);
      this.dsq = window.setInterval(() => {
        this.getPayResult(id);
      }, 10000);
    }
  }

  /**
   * 卸载
   * @protected
   * @returns any
   */
  public beforeDestroy() {
    window.clearInterval(this.dsq);
  }

  /**
   *  获取微信二维码
   * @protected
   * @returns void
   */
  protected async getPay(data: any): Promise<void> {
    try {
      let { content: result } = await this.skcServerOrderService.skcServerOrderConfirm(data);
      if (result.data) {
        this.weImg = result.data;
      }
    } catch (err) {
      this.$message.error({
        duration: 3,
        content: JSON.stringify(err),
      });
    }
  }
  /**
   * 订单数据
   */
  protected dataJson: IServerModel = {};
  /**
   *  获取订单明细
   * @protected
   * @returns void
   */
  protected async getSkcServerOrder(id: number): Promise<void> {
    try {
      let { content: result } = await this.skcServerOrderService.getSkcServerOrder(id);
      if (result.data) {
        this.dataJson = result.data;
      }
    } catch (err) {
      this.$message.error({
        duration: 3,
        content: JSON.stringify(err),
      });
    }
  }
  /**
   *  获取订单结果
   * @protected
   * @returns void
   */
  protected async getPayResult(id: number): Promise<void> {
    try {
      let { content: result } = await this.skcServerOrderService.getPayResult(id);
      if (result && result.data) {
        // 非待付款
        if (result.data.status != 1) {
          this.$router.push({ name: "version-payResult", query: { id: id.toString() } });
        }
      }
    } catch (err) {
      this.$message.error({
        duration: 3,
        content: JSON.stringify(err),
      });
    }
  }
  /**
   * 注销登录
   * @protected
   * @return void
   */
  protected async logout(): Promise<void> {
    try {
      await this.userService.logout();
    } catch (err) {
      this.$message.error({
        duration: 3,
        content: err || "服务器错误",
      });
    }
  }

  /**
   * 退出登录
   * @protected
   * @returns void
   */
  protected loginOut(): void {
    this.$confirm({
      title: "提示",
      content: "是否确定注销登录 ?",
      okText: "确定",
      cancelText: "取消",
      onOk: async () => {
        return await this.logout()
          .then(() => {
            setTimeout(() => {
              localStorage.clear();
              this.$router.push("/");
            }, 20);
          })
          .catch(() => {
            this.$message.error("注销失败");
          });
      },
      onCancel() {},
    });
  }
  // 提交凭证
  protected submitVoucher(): void {
    (this.$refs.voucher as any).show(this.dataJson);
  }
  // 更改支付类型
  protected changeType(item: any): void {
    this.payType.filter((res) => res.id != item.id).map((res1) => (res1.checked = false));
    this.payType.filter((res) => res.id == item.id)[0].checked = true;
  }

  /**
   * 返回首页
   * @protected
   * @returns void
   */
  protected gotoIndex(): void {
    this.$router.push({ name: "shop" });
  }
}
